import { BsArrowThroughHeart } from 'react-icons/bs'

import UserAppContext from "../../hook/UserAppContext"
import Title from '../../components/title/Title'

const Crush = ({isCurrent}) => {

      if(isCurrent !== 'crush') return 

      const {user} = UserAppContext()
      const {relation} = user.user 
      const AVATAR = `https://api.dicebear.com/5.x/initials/svg?seed=${relation.name}&font-size=26`

      return (
            <div className={isCurrent === 'crush' ? "wrapper_page show" : "wrapper_page"}>
                  <div className="page__inner">
                        <Title text={relation.relation_type}/>
                        <div className="relation_content">
                              <div className="relation_header">
                                    <div className="relation_avatar">
                                          <img src={relation.avatar === '' ? AVATAR : relation.avatar} alt={relation.name} />
                                    </div>
                                    <div className="relation_data">
                                          <strong>{relation.name}</strong>
                                          <span>{relation.id_xat}</span>
                                          <a href={relation.me === '' ? "https://xat.com" : relation.me}>xat.me</a>
                                    </div>
                              </div>
                              <div className="relation_about">
                                    <p>{relation.about}</p>
                              </div>
                              <div className="relation_footer">
                                    <BsArrowThroughHeart />
                                    <h3>{relation.love_count.time_lapse}</h3>
                                    <BsArrowThroughHeart />
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Crush